export const GET_PARTNER_START = 'GET_PARTNER_START';
export const GET_PARTNER_FAILED = 'GET_PARTNER_FAILED';
export const GET_PARTNER_SUCCESS = 'GET_PARTNER_SUCCESS';
